// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 678 ? "component---src-pages-index-js" : chunkId) + "-" + {"231":"f13b142605df229f5550","589":"d098282cd1a3c91d4b6e","610":"46527e4d4c38a88a35fe","678":"39f359235581b199b199","711":"41b6dbb9317d35d5e3e3"}[chunkId] + ".js";
};